module.exports = __webpack_public_path__ + "img/p2_di.1d0fdae8.png";